import {
  ExchangeAntispamRuleActionType,
  ExchangeAntispamRule,
  ExchangeRuleScopeApplyToType,
  ExchangeRuleScopeEmailSelection,
  ExchangeAntispamActiveState,
} from '@nirvana/shared/dtos/types/policies/common';
import { Column, ColumnKeys } from './grid-config';
import { GzPolicyUiSettingsGridDataProvider } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/gridComponents/gridView/dataProvider/GzPolicyUiSettingsGridDataProvider';
import { SetFiltersRequest } from '../../../../../../../../grid/types/common';
import { convertRegexFilterToStartsWithFilter } from '../../../../../../../common/policyPanel/uiSettings/gridTemplate/utils/filters-converters';

export interface ExchangeAntispamRuleFrontendFields extends ExchangeAntispamRule {
  applyTo: ExchangeRuleScopeApplyToType;
  senders: ExchangeRuleScopeEmailSelection;
  recipients: ExchangeRuleScopeEmailSelection;
  mainAction: ExchangeAntispamRuleActionType;
  activeState: ExchangeAntispamActiveState;
}
export class GzExchangeAntispamRulesGridDataProvider extends GzPolicyUiSettingsGridDataProvider<
  Column,
  ColumnKeys,
  ExchangeAntispamRule
> {
  protected getItemsWithAdditionalFrontendFields(items: ExchangeAntispamRule[]): ExchangeAntispamRuleFrontendFields[] {
    return items.map(item => {
      return {
        ...item,
        applyTo: item.scope.applyTo,
        senders: item.scope.from,
        recipients: item.scope.to,
        mainAction: item.actions.type,
        activeState: item.active ? ExchangeAntispamActiveState.ACTIVE : ExchangeAntispamActiveState.INACTIVE,
      };
    });
  }

  async setFilters(request: SetFiltersRequest<ColumnKeys>): Promise<{} | undefined> {
    // convert regex to startsWith
    convertRegexFilterToStartsWithFilter(request, ColumnKeys.RULE_NAME);
    return;
  }
}
